import { Modal } from 'antd';
import * as queryString from 'query-string';
import { getIntl, getLocale } from 'umi';
import { transform2HantFormat } from '@/locales/lang';
import { getModalConfig } from './components/Modal/useModalMethod';
import locale from './parseLocale';
import { isMobile } from './utils';
import { getPlatformFormQuery } from './utils/platform';

const showCloseModal = (handler) => {
  const intl = getIntl(getLocale());
  Modal.confirm({
    ...getModalConfig(intl),
    title: intl.formatMessage({ id: '温馨提示' }),
    content: intl.formatMessage({ id: '确认放弃当前操作，并退出' }),
    onOk() {
      handler?.();
    },
  });
};

/**
 * 初始化pc端的header
 */
const initHeader = () => {
  if (isMobile()) {
    return;
  }
  // @ts-expect-error
  const { yiwangheader } = window;
  if (yiwangheader) {
    yiwangheader.init(
      ENV,
      (height) => {
        const rootElem = document.getElementById('root');
        if (!rootElem) return;
        rootElem.style.paddingTop = `${height}px`;
        rootElem.style.transition = 'padding-top 0.5s ease';
      },
      {
        // 拦截头部的重定向相关跳转，在跳转前弹出提示窗口
        onHandleReplaceUrl: (e) => {
          showCloseModal(() => {
            window.location.href = e.data.url;
          });
        },
        // 拦截头部的的语言切换，在跳转前弹出提示窗口
        onHandleChangeLanguage: (e) => {
          const { language } = e.data;
          if (language === transform2HantFormat(getLocale())) return;
          showCloseModal(() => {
            yiwangheader.postChangeLanguage?.(e.data.language);
            const param = queryString.parseUrl(window.location.href);
            const newUrl = queryString.stringifyUrl({
              ...param,
              query: {
                ...param.query,
                language: e.data.language,
              },
            });
            window.location.replace(newUrl);
          });
        },
        // 拦截头部的的登出操作，在跳转前弹出提示窗口
        onHandleLogout: (e) => {
          showCloseModal(() => {
            window.location.href = e.data.url;
            yiwangheader.postLogout(e);
            setTimeout(() => {
              window.location.href = e.data.url;
            }, 1500);
          });
        },
      },
      {
        // 根據地址欄的platform參數判斷是用一戶通的header還是商社通的header
        platform: getPlatformFormQuery(),
      },
    );
  }
};
initHeader();

export { locale };
